interface LocalArrangementProps {
  ref: string
}

export default function LocalArrangement({ ref: refId }: LocalArrangementProps) {
  // In production, this component looks up the convention's local arrangements
  // and renders the matching ref. If not found, it renders nothing.
  // For now, this is a stub that will be implemented when the convention data
  // pipeline is wired up.
  return (
    <div className="local-arrangement" data-ref={refId}>
      {/* Local arrangement: {refId} */}
    </div>
  )
}
